const SDK_VERSION = '7.94.1';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
